var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5113 1.24382C17.9019 0.853298 18.535 0.853296 18.9256 1.24382L23.1682 5.48644C23.3557 5.67397 23.4611 5.92833 23.4611 6.19355C23.4611 6.45876 23.3557 6.71312 23.1682 6.90065L7.61186 22.457C7.42432 22.6445 7.16996 22.7499 6.90473 22.7499L2.66222 22.7498C2.10995 22.7498 1.66226 22.3021 1.66224 21.7498L1.66211 17.5073C1.6621 17.2421 1.76746 16.9877 1.955 16.8002L17.5113 1.24382ZM18.2185 3.36514L3.66212 17.9215L3.66221 20.7498L6.49055 20.7499L21.0469 6.19355L18.2185 3.36514Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2685 5.4865C13.659 5.09597 14.2922 5.09597 14.6827 5.4865L18.9253 9.72915C19.3159 10.1197 19.3159 10.7528 18.9253 11.1434C18.5348 11.5339 17.9017 11.5339 17.5111 11.1434L13.2685 6.90071C12.878 6.51019 12.878 5.87702 13.2685 5.4865Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.da2e594d5ca3021d36417593511ac9fe.svg";
export { ForwardRef as ReactComponent };